import router from '@/router';

export default (error, exception) => {
    location.href = router.resolve({ name: 'verify-email' }).href
}    
